<template>
	<a :href="href" :class="classList" :target="target">
		<slot></slot>
	</a>
</template>

<script type="text/babel">
export default {
	props: {
		href: { default: "#" },
		extraClasses: { default: "" },
		type: { default: "regular" }, // regular, outline, white
		variant: { default: "normal" }, // normal, cta
		isLoading: { default: false },
		isFull: { default: false },
		widthSize: { default: "normal" },
		target: { default: "_self" },
	},

	computed: {
		classList() {
			let classList = "button button-link";

			classList += " " + this.type;
			classList += " w-size-" + this.widthSize;

			if (this.variant !== "normal") {
				classList += " " + this.variant;
			}

			if (this.isLoading) {
				classList += " is-loading";
			}

			if (this.isFull) {
				classList += " is-full";
			}

			if (this.extraClasses !== "") {
				classList += " " + this.extraClasses;
			}

			return classList;
		},
	},
};
</script>
